/*
 * QuoteDashboard.tsx : Un simple appel à QuoteVersionDashboard selon la derniere version disponible pour ce devis.
 */

// Imports React
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Import Devis
import { QuoteData, QuoteVersionData } from '../types/types';
import { quotesApi } from '../services/quotesApi';

// QuoteDashboard page component
const QuoteDashboard: React.FC = () => {
	// Hooks de State
	const [loading, setLoading] = React.useState(true);
	const [formData, setFormData] = React.useState<QuoteData>({
		id: 0,
		referenceNumber: '',
		budgeted: false,
		quoteVersions: [],
	});
	// Hook de Navigation et Paramètres de navigation
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();

	// Une fois le composant monté et si un id est présent, fetch et préremplissage du formulaire
	React.useEffect(() => {
		// Vérification du token d'authentification
		const token = localStorage.getItem('token');
		if (!token) return;
		// Si un id est présent, on fetch le devis
		if (id) {
			quotesApi
				.get(Number(id), token)
				.then((data: QuoteData) => {
					setFormData(data);
					// Redirection vers la dernière version
					if (data.quoteVersions && data.quoteVersions.length > 0) {
						const getLatest = (versions: QuoteVersionData[]) =>
							versions.reduce((prev, current) =>
								prev.versionIndex > current.versionIndex ? prev : current
							);

						const activeVersions = data.quoteVersions.filter(
							(v) => v.status !== 'CANCELED'
						);

						const latestVersion =
							activeVersions.length > 0
								? getLatest(activeVersions)
								: getLatest(data.quoteVersions);

						navigate(`/app/quoteVersions/${latestVersion.id}/manage`);
					}
					setLoading(false);
				})
				.catch((error) => {
					console.error('Erreur lors du chargement du devis :', error);
					setLoading(false);
				});
		} else {
			setLoading(false);
		}
	}, [id, navigate]);

	// Simple message pour signaler qu'aucune version n'existe pour ce devis.
	return (
		<div>
			{loading ? <p>Redirection vers la dernière version du devis...</p> : null}
			{!loading && formData.quoteVersions?.length === 0 ? (
				<p>Aucune version de devis n&apos;existe pour ce devis.</p>
			) : null}
		</div>
	);
};

export default QuoteDashboard;
